import { InjectionToken } from "@angular/core";

export abstract class ICookieInformationDialogService
{

  public abstract cookieInformationDialogShow(
    callbackAgree: () => void
  ): unknown;

}
/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ICookieInformationDialogServiceToken = new InjectionToken<ICookieInformationDialogService>('ICookieInformationDialogServiceToken');
